import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// internal import
import Loader from "../../../components/common/Loader";
import apiLink from "../../../api/apiLink";
import useISPowner from "../../../hooks/useISPOwner";

const CustomerManualEdit = () => {
  const { t } = useTranslation();

  //---> @Get user & current user data form useISPOwner hooks
  const { ispOwnerId, bpSettings, settings } = useISPowner();

  const [isLoading, setIsLoading] = useState(false);
  const [manualEditStatus, setManualEditStatus] = useState(false);
  const [sendingType, setSendingType] = useState("nonMasking");

  const messageTypes = [
    {
      name: "nonMasking",
      label: t("nonMasking"),
      value: "nonMasking",
    },
    {
      name: "masking",
      label: t("masking"),
      value: "masking",
    },
    {
      name: "fixedNumber",
      label: t("fixedNumber"),
      value: "fixedNumber",
    },
    ...(bpSettings?.hasSmsGateway
      ? [
          {
            name: "personalGateway",
            label: t("personalGateway"),
            value: "personalGateway",
          },
        ]
      : []),
  ];

  // handle submit method
  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      customerInactiveManualSendBy: sendingType,
      customerInactiveManual: manualEditStatus,
    };
    setIsLoading(true);
    // api call
    try {
      await apiLink.patch(`/ispOwner/settings/sms/${ispOwnerId}`, data);
      toast.success(t("manualInactiveToast"));
    } catch (error) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setSendingType(settings?.sms?.customerInactiveManualSendBy);
    setManualEditStatus(settings?.sms?.customerInactiveManual);
  }, [settings]);

  return (
    <div>
      <div className="writeMessageSection">
        <div className="messageStatus d-flex justify-content-between">
          <div className="sending-status">
            <h4> {t("manualInactive")} </h4>
            <div className="displayGrid1">
              <div className="message_radio">
                <input
                  type="radio"
                  name="assignTicket"
                  id="onTemplate_update"
                  checked={manualEditStatus}
                  onChange={() => setManualEditStatus(true)}
                />
                <label htmlFor="onTemplate_update">{t("ON")}</label>
              </div>

              <div className="message_radio">
                <input
                  type="radio"
                  name="assignTicket"
                  id="offTemplate_update"
                  checked={!manualEditStatus}
                  onChange={() => setManualEditStatus(false)}
                />
                <label htmlFor="offTemplate_update">{t("OFF")}</label>
              </div>
            </div>
          </div>
          <div className="message-sending-type">
            <h4>{t("sendingMessageType")}</h4>
            <div className="smsType">
              {messageTypes.map((type) => (
                <div className="message_radio" key={type.value}>
                  <input
                    type="radio"
                    id={type.value + "update"}
                    value={type.value}
                    onChange={(event) => setSendingType(event.target.value)}
                    checked={sendingType === type.value}
                  />
                  <label htmlFor={type.value + "update"}>{type.label}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <hr />
      <button type="submit" onClick={handleSubmit} className="btn btn-success">
        {isLoading ? <Loader /> : t("save")}
      </button>
    </div>
  );
};

export default CustomerManualEdit;
